<script>
import {HorizontalBar, mixins} from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: HorizontalBar,
  mixins: [reactiveProp],
  data () {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: true,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            stacked: true,
            ticks: {
              beginAtZero: true,
              max: 120,
              min: 0,
              precision: 1,
              display: false
            },
            gridLines: {
              display: false
            }
          }],
          yAxes: [{
            gridLines: {
              display: false
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              let value = data.datasets[0].data[tooltipItem.index]
              let label = data.labels[tooltipItem.index]

              return label + ': ' + value + ' %'
            }
          }
        },
        plugins: {
          datalabels: {
            display: true,
            anchor: 'end',
            align: 'end',
            textAlign: 'center',
            clamp: true,
            color: '#0099FF',
            font: {
              size: 11
            },
            formatter: function (value, context) {
              return value + '%'
            }
          }
        }
      }
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/board/elements/horizontalBarChart.vue